import React from "react";
import { formatNumber } from "components/day/summary";

// An advice reply laid out rather than written out: where the day stands as a
// coloured chip, the nutrients that are off as small flags, and the next meal
// as one row with its kcal and grams in the macro colours — made from what is
// in. With nothing in to make it from (`needsFood`), the row is a question
// instead: what do you have? (A `buy` line is shown on advice kept before.)
// The parts are model/chat.adviceOf's; the chip's colour is the server's own
// kcal left (`left`), never the model's arithmetic.
const MACROS = [
  ["protein", "P"],
  ["carbs", "C"],
  ["fat", "F"],
  ["fiber", "fiber"],
];

const statusTone = (left) => (left === null || left === undefined ? "none" : left > 0 ? "room" : "over");

const FLAG_ICON = { low: "fa-arrow-down", high: "fa-arrow-up", ok: "fa-check" };

export const AdviceCard = ({ advice }) => {
  const { status, left, flags = [], options = [], buy, answer, needsFood } = advice;
  return (
    <div className="noshchat-advice" data-testid={"chat-advice"}>
      {status || flags.length ? (
        <div className="noshchat-advice__head">
          {status ? (
            <span className={`noshchat-advice__status noshchat-advice__status--${statusTone(left)}`} data-testid={"chat-advice-status"}>
              <i className="fa fa-bullseye" /> {status}
            </span>
          ) : null}
          {flags.map((flag) => (
            <span
              key={`${flag.macro}-${flag.text}`}
              className={`noshchat-advice__flag noshchat-advice__flag--${flag.macro} noshchat-advice__flag--${flag.level}`}
              data-testid={"chat-advice-flag"}
            >
              <i className={`fa ${FLAG_ICON[flag.level] || FLAG_ICON.ok}`} /> {flag.text}
            </span>
          ))}
        </div>
      ) : null}

      {needsFood ? (
        <div className="noshchat-advice__needs" data-testid={"chat-advice-needs"}>
          <i className="fa fa-shopping-basket" />
          <span>{answer || "Tell me what food you have, e.g. \"I have eggs, rice and tomatoes\", and I'll suggest your next meal."}</span>
        </div>
      ) : answer ? (
        <div className="noshchat-advice__answer">{answer}</div>
      ) : null}

      {options.length ? (
        <ul className="noshchat-advice__options">
          {options.map((option, i) => (
            <li key={i} className="noshchat-advice__option" data-testid={"chat-advice-option"}>
              <div className="noshchat-advice__top">
                <span className="noshchat-advice__label">{option.label}</span>
                <span className="noshchat-advice__kcal">≈{formatNumber(option.kcal)} kcal</span>
              </div>
              <div className="noshchat-advice__food">{option.food}</div>
              <div className="noshchat-advice__macros">
                {MACROS.map(([macro, letter]) => (
                  <span key={macro} className={`noshchat-advice__macro noshchat-advice__macro--${macro}`}>
                    {formatNumber(option[macro])} g {letter}
                  </span>
                ))}
              </div>
            </li>
          ))}
        </ul>
      ) : null}

      {buy ? (
        <div className="noshchat-advice__buy" data-testid={"chat-advice-buy"}>
          <i className="fa fa-shopping-cart" /> {buy}
        </div>
      ) : null}
    </div>
  );
};
